import { render } from "./OneStopProcess.vue?vue&type=template&id=608b485a&scoped=true"
import script from "./OneStopProcess.vue?vue&type=script&lang=js"
export * from "./OneStopProcess.vue?vue&type=script&lang=js"

import "./OneStopProcess.vue?vue&type=style&index=0&id=608b485a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608b485a"]])

export default __exports__